/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_League_NameInputs */

const ja_playdata_pricing_league_name = /** @type {(inputs: Playdata_Pricing_League_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`League Plan`)
};

const en_playdata_pricing_league_name = /** @type {(inputs: Playdata_Pricing_League_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`League Plan`)
};

/**
* | output |
* | --- |
* | "League Plan" |
*
* @param {Playdata_Pricing_League_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_league_name = /** @type {((inputs?: Playdata_Pricing_League_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_League_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_league_name(inputs)
	return en_playdata_pricing_league_name(inputs)
});